//全局 变量

  //  systemIp='127.0.0.1:8080',
     systemIp='jmsw.fsyszz.com',
  //      systemIp='test.jmsw.fsyszz.com',
  parameters = {
     // domain: 'http://'+systemIp+"/wtshuiwen",
    domain: 'https://'+systemIp+"/wtshuiwen",
    domain2: 'http://'+systemIp+"/wtshuiwen",
    //domain3: 'ws://'+systemIp,
    domain3: 'ws://'+"127.0.0.1:18080",
    system_id: '3000000',
  }



// WEBPACK FOOTER //
// ./src/global/setting.js